/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-wrap-multilines */
// eslint-disable-next-line react/jsx-closing-tag-location
import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import * as React from 'react';
import AgapeIcon from '../../icons/AgapeIcon';

const useStyles = makeStyles((theme) => ({
  notificationTooltip: (props) => ({
    padding: '10px',
    border: 'solid 1px #f8f9fe',
    borderRadius: '6px',
    maxWidth: '450px',
    boxShadow: '0 1px 3px 0 rgba(50, 50, 93, 0.18)',
    backgroundColor: '#ffffff',
    '& *': {
      color: props.tooltipTextColor,
    },
  }),
  profileTooltipArrow: {
    color: '#ffffff !important',
    fontSize: '1.4rem',
  },
  t1: {
    fontWeight: 'bold',
  },
}));

const InnerComponent = React.forwardRef(function MyComponent(props, ref) {
  //  Spread the props to the underlying DOM element.
  const { iconColor } = props;
  return (
    <div {...props} ref={ref}>
      <AgapeIcon icon="t-info" size="1.6rem" color={iconColor} />
    </div>
  );
});

const CallAgapeTooltip = ({
  IsOptionalText,
  iconColor,
  tooltipTextColor = 'black',
}) => {
  const classes = useStyles({ tooltipTextColor });

  return (
    <Tooltip
      interactive
      PopperProps={{
        disablePortal: true,
      }}
      classes={{
        tooltip: classes.notificationTooltip,
        arrow: classes.profileTooltipArrow,
      }}
      title={
        <>
          <Typography>
            {IsOptionalText ||
              'برای ویرایش فیلدهایی که قادر به ویرایش آن نیستید، با آگاپه تماس بگیرید'}
          </Typography>
          {!IsOptionalText && (
            <a className={classes.tel} href="tel:+982122040078">
              <Typography className={classes.t1}>021-22040078</Typography>
            </a>
          )}
        </>
      }
      placement="bottom-start"
      arrow
    >
      <InnerComponent iconColor={iconColor} />
    </Tooltip>
  );
};

export default CallAgapeTooltip;
